const isWarningBannerVisible = () => {
  return typeof window !== 'undefined'
    ? localStorage.getItem('delwp-swm-is-warning-banner-closed') !== 'true'
    : false
}

export default isWarningBannerVisible
